import React, { FC } from 'react';
import { LightHeader } from '../../header/light/LightHeader';
import { NavGroup } from '../../navigation/components/group/NavGroup';
import { NavHeader } from '../../navigation/components/header/NavHeader';
import { Nav } from '../../navigation/components/Nav';
import { NavCustomerButton } from '../../navigation/customers/NavCustomerButton';
import { NavLoginButton } from '../../navigation/login/NavLoginButton';
import { NavPublicPricing } from '../../navigation/pricing/NavPublicPricing';
import { NavSignupButton } from '../../navigation/signup/NavSignupButton';
import { NavToDoctrine } from '../../navigation/NavToDoctrine';
import { useUser } from '../../user/useUser';
import {
  NavPersonaJuriste,
  NavPersonaLawyer,
} from '../../navigation/personas/NavPersonasButtons';

const BaseHeader: FC = ({ children }) => (
  <LightHeader source="nav">
    <NavHeader>
      <NavGroup>
        <Nav dataTestId="nav-public">
          <NavPersonaLawyer />
          <NavPersonaJuriste />
          <NavCustomerButton />
          <NavPublicPricing />
          {children}
        </Nav>
      </NavGroup>
    </NavHeader>
  </LightHeader>
);

const LoggedInHeader: FC = () => (
  <BaseHeader>
    <NavToDoctrine />
  </BaseHeader>
);

export const LoggedOutHeader: FC<{ pageName: string }> = ({ pageName }) => (
  <BaseHeader>
    <NavLoginButton />
    <NavSignupButton manualSourcePage={pageName} />
  </BaseHeader>
);

export const PublicHeader: FC<{ pageName: string }> = ({ pageName }) => {
  const { loggedIn } = useUser();
  return loggedIn ? (
    <LoggedInHeader />
  ) : (
    <LoggedOutHeader pageName={pageName} />
  );
};
